import { Units, useUnitsComponent } from "../../Styles";
import { TestData as Pens } from '../../Assets/TestData/lf_Data';
import { ReportTemplate } from "./reportTemplates";
import { useTranslation } from "react-i18next";
import { TestData as AnimalData, Animals } from '../../Assets/TestData/animalData';

export type ProgressCircle = {
  header?: string
  unit?: JSX.Element
  progresed: number
  total: number
  show: boolean
}

export type Feeding = {
  progressCircle: ProgressCircle[];
  report?: ReportTemplate['reportTemplateNo'][]
};

export const useFeedingData = (): Feeding[] => {
  const getUnit = useUnitsComponent();
  const {t} = useTranslation();

  const totalNumberOfPens = Pens.length;
  const totalNumberOfAnimals = Pens.filter((pen) => pen.animalId).length;

  return [
    {
      progressCircle: [
        { header: t("feed.remaining.today"), unit: getUnit(Units.kG_grey), progresed: totalNumberOfAnimals, total: totalNumberOfPens, show: true },
        { header: t("feed.remaining.yesterday"), unit: getUnit(Units.kG_grey), progresed: totalNumberOfAnimals, total: totalNumberOfPens, show: true },
        { header: t("feed.fed.today"), unit: getUnit(Units.kG_grey), progresed: totalNumberOfAnimals, total: totalNumberOfPens, show: true },
        { header: t("feed.fed.period"), unit: getUnit(Units.kG_grey), progresed: totalNumberOfAnimals, total: totalNumberOfPens, show: false },
      ],
      report: [5, 6]
    }
  ];
};

export type Calendar = {
  progressCircle: ProgressCircle[];
  report?: ReportTemplate['reportTemplateNo'][]
};

export const useCalendarData = (): Calendar[] => {
  const getUnit = useUnitsComponent();
  const {t} = useTranslation();


  const totalNumberOfPens = Pens.length;
  const totalNumberOfAnimals = Pens.filter((pen) => pen.animalId).length;

  return [
    {
      progressCircle: [
        { header: t("reports.farrowingsToday"), unit: getUnit(Units.animalTotal_grey), progresed: totalNumberOfAnimals, total: totalNumberOfPens, show: true },
        { header: t("reports.farrowed"), unit: getUnit(Units.animalTotal_grey), progresed: totalNumberOfAnimals, total: totalNumberOfPens, show: true },
        ],
      report: [7]
    }
  ];
};

// Progress circles on feeding
export type DefaultProgressCircle = {
  progressCircleId: number
  header: string
  unit: JSX.Element
  progressed: number
  total: number
}
export const useDefaultProgressCircles = (): DefaultProgressCircle[] => {
  const getUnit = useUnitsComponent();
  const {t} = useTranslation();
  
  const filteredAnimalData = AnimalData.filter(animal => animal.locationId === 1);

  const totalNumberOfAnimals = filteredAnimalData.length
  
  const totalFeed = filteredAnimalData.reduce((accum, animal: Animals) => {
    return accum + (animal.totalFood || 0);
  }, 0);

  const remainingToday = filteredAnimalData.reduce((accum, animal: Animals) => {
    return accum + (animal.remainingToday || 0);
  }, 0);

  const remainingYesterday = filteredAnimalData.reduce((accum, animal: Animals) => {
    return accum + (animal.remainingYesterday || 0);
  }, 0);

  const FEED_BALANCE = 0.20

  const notFedLastDays = filteredAnimalData.filter((animal: Animals) => {
    const remainingToday = animal.remainingToday || 0;
    const remainingYesterday = animal.remainingYesterday || 0;
    const feedThreshold = FEED_BALANCE * (animal.totalFood || 0);

    return remainingToday < feedThreshold && remainingYesterday < feedThreshold;
  }).length;

  return [
    { progressCircleId: 1, header: t("feed.remaining.today"), unit: getUnit(Units.kG_grey), progressed: remainingToday, total: totalFeed},
    { progressCircleId: 2, header: t("feed.remaining.yesterday"), unit: getUnit(Units.kG_grey), progressed: remainingYesterday, total: totalFeed},
    { progressCircleId: 3, header: "Water Today", unit: getUnit(Units.kG_grey), progressed: remainingToday, total: totalFeed},
    { progressCircleId: 4, header: "Not fed Last 2 days", unit: getUnit(Units.animalTotal_grey), progressed: notFedLastDays, total: totalNumberOfAnimals},
  ]
}
